import type { NetworkFields, NetworkSettingsFields } from '@ms/yammer-graphql';

import type { NormalizedCurrentNetwork } from '../../../state/types';

interface CurrentNetworkFields extends NetworkFields {
  readonly permalink: NetworkSettingsFields['permalink'];
  readonly isLegacyExternalNetwork?: NetworkSettingsFields['isLegacyExternalNetwork'];
  readonly isNativeModeSharePointOnlyFileStorage: NetworkSettingsFields['isNativeModeSharePointOnlyFileStorage'];
  readonly isTranslationEnabled: NetworkSettingsFields['isTranslationEnabled'];
  readonly webClientSettings: NetworkSettingsFields['webClientSettings'];
  readonly isForcedNotificationEnabled: NetworkSettingsFields['isForcedNotificationEnabled'];
  readonly isDirectMessagesEnabled: NetworkSettingsFields['isDirectMessagesEnabled'];
}

type ProcessCurrentNetwork = (value: CurrentNetworkFields) => NormalizedCurrentNetwork;
export const processCurrentNetwork: ProcessCurrentNetwork = ({
  id,
  displayName,
  permalink,
  isLegacyExternalNetwork,
  isNativeModeSharePointOnlyFileStorage,
  isTranslationEnabled,
  webClientSettings: { isWebPushNotificationsEnabled },
  isForcedNotificationEnabled,
  isDirectMessagesEnabled,
}) => ({
  id,
  displayName,
  permalink,
  isLegacyExternalNetwork: !!isLegacyExternalNetwork,
  isNativeModeSharePointOnlyFileStorage,
  isTranslationEnabled,
  isWebPushNotificationsEnabled,
  isForcedNotificationEnabled,
  isDirectMessagesEnabled,
});
